import AsyncStorage from '@react-native-async-storage/async-storage';
import AbstractNotificationService from './AbstractNotificationService';

const MS_IN_MINUTE = 60000;
const NOTIF_KEY = 'notif_key';

/* eslint-disable no-return-assign */
/* eslint-disable no-sequences */
const filter = (obj, predicate) =>
    Object.keys(obj)
        .filter((key) => predicate(obj[key]))
        .reduce((res, key) => ((res[key] = obj[key]), res), {});

/** @class {AbstractNotificationService} */
class NotificationsService extends AbstractNotificationService {
    static schedules = {};

    static async setup() {
        try {
            const jsonValue = await AsyncStorage.getItem(NOTIF_KEY);
            if (jsonValue) {
                const allNotifications = JSON.parse(jsonValue);
                const filtered = filter(
                    allNotifications,
                    (notif) => notif.scheduleTime > Date.now()
                );
                NotificationsService.schedules = filtered;
                return filtered;
            }
        } catch (error) {
            // console.log(error);
        }
        return null;
    }

    static getNotification(item) {
        const itemId = `${item.getId()}`;
        const notification = NotificationsService.schedules[itemId];
        return notification ? { timeOffsetMin: notification.timeOffsetMin } : undefined;
    }

    static async scheduleNotification(item, timeOffsetMin) {
        const itemId = `${item.getId()}`;
        const scheduleTime = item.getStartTime() - timeOffsetMin * MS_IN_MINUTE;
        const notification = { scheduleTime, timeOffsetMin };
        try {
            NotificationsService.schedules[itemId] = notification;
            const jsonNotifications = JSON.stringify(NotificationsService.schedules);
            await AsyncStorage.setItem(NOTIF_KEY, jsonNotifications);
        } catch (error) {
            // console.log(error);
        }
        return true;
    }

    static async cancelScheduledNotification(item) {
        try {
            const itemId = item.getId();
            delete NotificationsService.schedules[itemId];
            const jsonNotifications = JSON.stringify(NotificationsService.schedules);
            await AsyncStorage.setItem(NOTIF_KEY, jsonNotifications);
        } catch (error) {
            console.log(error);
        }
    }
}

export default NotificationsService;
